/**
 * Query-param controlled scenario hints (P1-G13 + P1-G19 + P1-G11).
 *
 * Demo URLs include `?retry=fail`, `?smoke=timeout`, `?ai=slow` to drive
 * deterministic mock outcomes. Without params the mock takes the happy path.
 */

export type RetryOutcome = 'succeed' | 'fail';
export type SmokeOutcome = 'ok' | 'timeout' | 'tool-fail';
export type AiSpeed = 'fast' | 'slow';

export interface ScenarioHints {
  retry: RetryOutcome;
  smoke: SmokeOutcome;
  ai: AiSpeed;
}

export function readScenarioHints(): ScenarioHints {
  const params = new URLSearchParams(window.location.search);
  const slowFromStorage = sessionStorage.getItem('mock-slow-ai') === 'true';

  return {
    retry: (params.get('retry') as RetryOutcome) === 'fail' ? 'fail' : 'succeed',
    smoke:
      params.get('smoke') === 'timeout'
        ? 'timeout'
        : params.get('smoke') === 'tool-fail'
          ? 'tool-fail'
          : 'ok',
    ai: params.get('ai') === 'slow' || slowFromStorage ? 'slow' : 'fast',
  };
}
